import { Component, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AppSelectors } from '../../../../store/app/app.selectors';
import { InfoBlockComponent } from '../../../../shared/components/info-card-block/info-block.component';
import { AsyncPipe } from '@angular/common';
import { BusinessSize } from '../../../../_interfaces/business.interface';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';
import { OffcanvasService } from '../../../../_services/offcanvas-service/offcanvas.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-business-details',
  imports: [InfoBlockComponent, LoaderComponent, AsyncPipe],
  templateUrl: './business-details.component.html',
})
export class BusinessDetailsComponent {
  readonly store = inject(Store);
  readonly offcanvasService = inject(OffcanvasService);

  readonly businessDetails$ = this.store.select(AppSelectors.businessDetails);
  readonly businessDetails = toSignal(this.businessDetails$, { initialValue: undefined });
  protected readonly BusinessSize = BusinessSize;

  onEditBusiness() {
    this.offcanvasService.offCanvasNavigate(`/settings/edit-business-details/${this.businessDetails()?.id}`);
  }
}
